module.exports = __webpack_public_path__ + "static/media/file.175d5993.svg";